import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isRTL from '@adsk/bim360-matrix-react-helpers/es/isRTL';

import IconButton from '@adsk/bim360-matrix-react-icon-button';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';

import closeIcon from '@adsk/bim360-matrix-react-assets/modal-close.svg';

import './_SnackBar.scss';

const SnackBar = props => {
  const icons = {
    info() {
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <g fill="none" fillRule="evenodd">
            <path fill="#FFF" d="M11 10h3v9h-3zM11 5h3v3h-3z" />
          </g>
        </svg>
      );
    },
    error() {
      return (
        <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
          <g fill="#FFF" fillRule="evenodd">
            <path d="M7 1h3v9H7zM7 12h3v3H7z" />
          </g>
        </svg>
      );
    },
    success() {
      return (
        <svg width="12" height="10" viewBox="0 0 12 10" xmlns="http://www.w3.org/2000/svg">
          <g fill="none" fillRule="evenodd">
            <path fill="none" d="M-2-3h16v16H-2z" />
            <path fill="#FFF" d="M4.8 7.5L9.6 0H12L6 10H3.6L0 5h2.4z" />
          </g>
        </svg>
      );
    }
  };
  icons.warning = icons.error;

  const isMessageElement = React.isValidElement(props.message);
  const contentClassNames = classNames('SnackBar__content', {
    'SnackBar__content--rtl': !isMessageElement && isRTL(props.message)
  });

  return (
    <div className="SnackBar__container">
      <span className={`SnackBar__level SnackBar__level--${props.level}`}>
        {icons[props.level]()}
      </span>
      <div className="SnackBar__content-container">
        <span className={contentClassNames}>
          {isMessageElement
            ? React.cloneElement(props.message, {
              closeNotification: () => props.removeNotification()
            })
            : props.message}
        </span>
        {props.dismissible && (
          <IconButton className="SnackBar__close" onClick={() => props.onDismiss()}>
            <SvgIcon>{closeIcon}</SvgIcon>
          </IconButton>
        )}
      </div>
    </div>
  );
};
SnackBar.defaultProps = {
  dismissible: true
};

SnackBar.propTypes = {
  level: PropTypes.string.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  removeNotification: PropTypes.func.isRequired,
  onDismiss: PropTypes.func,
  dismissible: PropTypes.bool
};

export default SnackBar;
